import axios from "axios";
import { settings } from "./setting";

export const getintegranteById =  async ({queryKey}) => {
    const res = await axios.get(`${settings.url}/hogar/integrante?id=${queryKey[1]}`)
    return res.data
}